
let userLang = (navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage
let locales = userLang.indexOf("_") !== -1 ? userLang.split("_") : userLang.split("-");
let language = locales[0]

export const baseUrl = `https://help.fast.cm/portal/${language}/kb/`;
